<template>
	<div>
	<!-- <div> -->

		<b-form-file
			class="mb-3"
			:ref="'edit_file_' + id"
			v-if="extern_file"
			accept=".csv, .txt,.xlsx,.xls"
			@change="addTabulator"
			placeholder="Importer un csv ou un xlsx pour édition"></b-form-file>

		<div v-if="select_mode">
			<b-button @click="mode = 'tabulator'" :variant="mode == 'tabulator' ? 'outline-primary': ''" >Tableau</b-button>&nbsp;
			<b-button @click="currentLineIndex = 1; mode = 'individual'" :variant="mode == 'individual' ? 'outline-primary': ''">Vue individuelle</b-button>
			<br /><br />
		</div>

		<div v-show="!hidden && mode == 'tabulator'"
            id="tabulator-holder"
            v-observe-visibility="{
                callback: (isVisible) => { if (isVisible) redraw(!wasRedrawn) },
            }">
			<VueTabulator
			style="overflow:visible !important;"
				class=""
				v-show="tabulator_options.columns.length"
				ref="tabulator"
				:id="id"
				v-model="tabulator_data"
				:options="tabulator_options"
				:integration="integration" />
		</div>

		<div v-show="!minimal && !hidden && mode == 'tabulator'" class="mb-3 flex justify-between">
			<b-button variant="link" v-b-toggle="'collapse-action' + id" v-if="!rules || (rules.filters == true || rules.download == true || rules.add_column == true || rules.add_line == true)">
				<i class="fas fa-cogs"> </i>
			</b-button>

			<!-- * slider pour lignes par page  -->
			<!-- * affiché que si le tabulator est chargé  -->
			<div class="flex items-center" v-if="tabulator_data.length > 0">
				<div class="mx-3">Lignes par page:</div>

				<b-dropdown
					:text="paginationSize.toString() + ' lignes'"
					class="">
					<b-dropdown-item
						v-for="n in 5"
						@click="() => (paginationSize = n * 10)"
						:key="n">
						{{ n * 10 }} lignes
					</b-dropdown-item>
				</b-dropdown>
			</div>
		</div>

		<b-collapse v-show="!hidden" :id="'collapse-action' + id">

			<b-tabs>
				<b-tab title="Export" v-if="(!rules || rules.download == true) && download">
					<b-col class="form-inline">
						<br /><br />
						<b-button @click="dowloadCSV"
							><i class="fas fa-file-download"></i> csv</b-button
						>
						&nbsp;
						<b-button @click="dowloadExcel"
							><i class="fas fa-file-download"></i> xlsx</b-button
						>
					</b-col>
				</b-tab>
				<b-tab v-if="!rules || rules.filters == true" title="Recherche"
					v-show="tabulator_options.columns.length > 0"
					class="search-col">
					<div class="mb-2 space-x-2 flex">
						<div
							v-for="(colFilter, i) in columnFilters"
							:key="colFilter"
							@click="() => removeColumnFilter(i)"
							class="bg-blue-600 rounded-sm text-white hover:bg-blue-700 hover:cursor-pointer hover:line-through">
							{{ colFilter }}
						</div>
					</div>

					<div class="mb-2">
						<span>
							Filtrer {{ filterColumns ? "colonnes" : "lignes" }}:
						</span>
						<span v-show="false"
							class="cursor-pointer opacity-30 line-through"
							@click="() => (filterColumns = !filterColumns)">
							{{ filterColumns ? "lignes" : "colonnes" }}
						</span>
					</div>
					<autocomplete
						v-show="filterColumns"
						base-class="autocomplete"
						ref="columnFilter"
						class="w-[30%] mb-2 rounded-lg focus:outline-none"
						@submit="(val) => addColumnFilter(val)"
						:search="searchCol"
						:autoSelect="true">
					</autocomplete>

					<div class="flex" v-show="!filterColumns">
						<b-form-input
							class="w-25"
							v-model="data_search"></b-form-input>
						&nbsp;
						<b-button v-on:click="search()"
							><i class="fas fa-search"></i> recherche</b-button
						>
					</div>
				</b-tab>
				<b-tab v-if="false && (!rules || (rules.add_column == true || rules.add_line == true)) && editor != false && row_updates" title="Insertion">
					<br />

					<b-form-input style="display:inline" v-if="!rules || rules.add_column == true"
						class="w-25"
						:list="'my-list-column' + id"
						v-model="name_column"></b-form-input>
					<datalist :id="'my-list-column' + id">
						<option></option>
						<option
							v-for="(item, index) in column_import_opt"
							:key="item">
							{{ index }}
						</option>
					</datalist>

					<b-button variant="link" v-if="!rules || rules.add_column == true" v-on:click="addColumn()"
						><i class="fas fa-plus-circle"></i>
						colonne</b-button
					>

					<hr />

					<div v-for="(column, idx) in tabulator_options.columns" :key="idx">
						<span v-show="!hidden_columns[column.title]"> {{ column.title }} </span><b-textarea v-show="!hidden_columns[column.title]" :rows="1" v-model="new_line[column.title]"></b-textarea>
					</div>

					<b-button variant="link"
						v-if="tabulator_options.columns.length > 0 && (!rules || rules.add_line == true)"
						v-on:click="addLine()"
						><i class="fas fa-plus-circle"></i> ligne au début</b-button
					>
					&nbsp;
					<b-button variant="link"
						v-if="tabulator_options.columns.length > 0 && (!rules || rules.add_line == true)"
						v-on:click="addLine(true)"
						><i class="fas fa-plus-circle"></i> ligne à la fin</b-button
					>

				</b-tab>
				<b-tab title="Visibilité des colonnes" v-if="false">

					<div v-for="(column, idx) in tabulator_options.columns" :key="idx">
						<b-button @click="hide_column(column.title)" variant="link"><i :class="hidden_columns[column.title] ? 'fas fa-eye-slash' : 'fas fa-eye'"></i></b-button>&nbsp;{{ column.title }}
					</div>

					<b-button variant="link" @click="hide_all">Tout cacher</b-button>
					<b-button variant="link" @click="show_all">Tout montrer</b-button><br />					
					Cacher les colonnes ayant moins de &nbsp;<b-input variant="link"style="width: 100px; display:inline" type="number" v-model="nb_items"></b-input>&nbsp;valeurs&nbsp;<b-button variant="link" @click="hide_column_items">Appliquer</b-button>
				</b-tab>
			</b-tabs>

		</b-collapse>

		<b-modal :title="view_file ? 'Fichier' : 'Texte'" size="xl" ok-only :id="'et-'+ id" @hide="hide_modal">
			<b-textarea v-show="!view_file" rows="10" v-model="edit_text"></b-textarea>
            <viewFile v-if="view_file" :data="view_file"></viewFile>           
			<viewFile v-else-if="edit_text.startsWith('http') && (edit_text.endsWith('.jpeg') || edit_text.endsWith('.jpg') || edit_text.endsWith('.png'))" :getDownload="false" :data="edit_text"></viewFile>
		</b-modal>

		<div v-if="tabulator_data.length && mode == 'individual'">

			<b-pagination
				v-model="currentLineIndex"
				:total-rows="tabulator_data.length"
				:per-page="1"
				aria-controls="line-navigation"
			></b-pagination>

			<div v-for="(column, idx_column) in tabulator_options.columns" :key="idx_column">
				{{ column.field }}

				<div v-if="(columns_type && columns_type[column.field] && columns_type[column.field].type == 'html') || (tabulator_data[currentLineIndex - 1][column.field].includes('<') && tabulator_data[currentLineIndex - 1][column.field].includes('>'))">
					<b-container style="margin: 0; padding: 0; max-width: none;">
						<b-row>
							<b-col>
								<ace_editor :height="tabulator_data[currentLineIndex - 1][column.field].length / 5 < 500 ? tabulator_data[currentLineIndex - 1][column.field].length / 5 : 500" mode="html" :code="tabulator_data[currentLineIndex - 1][column.field]" @update="tabulator_data[currentLineIndex - 1][column.field] = $event"></ace_editor>
							</b-col>
							<b-col>
								<contenteditable :contenteditable="true" tag="div" :noHTML="false" v-model="tabulator_data[currentLineIndex - 1][column.field]" style="max-height: 500px; overflow-y: auto; padding:10px"></contenteditable>
							</b-col>
						</b-row>
					</b-container>
				</div>
				<b-textarea v-else
					rows="2"
					max-rows="10"
					v-model="tabulator_data[currentLineIndex - 1][column.field]" />
			</div>

			<br />

			<b-pagination
				v-model="currentLineIndex"
				:total-rows="tabulator_data.length"
				:per-page="1"
				aria-controls="line-navigation"
			></b-pagination>
		</div>

		<div v-if="false">
			<div class="card-grid">
				<div
					v-for="(rowData, rowIndex) in paginatedData"
					:key="rowIndex"
					class="card"
				>
					<div class="card-content">
						Ligne {{ rowIndex + 1 + (currentPage - 1) * pageSize }}
						<div
							v-for="(column, idx_column) in tabulator_options.columns"
							:key="idx_column"
						>
							<strong>{{ column.field }}:</strong>
							<b-textarea
								v-model="rowData[column.field]"
							></b-textarea>
						</div>
					</div>
				</div>

				<div v-if="tabulator_data.length > 0 && tabulator_data.length > pageSize">
					<b-pagination
						v-model="currentPage"
						:total-rows="tabulator_data.length"
						:per-page="pageSize"
						aria-controls="table"
						align="center"
					></b-pagination>
				</div>
			</div>

		</div>
	</div>
</template>

<script>
	const chardet = require("chardet");

	import * as CSV from "csv-string";
	import uniqueId from "lodash.uniqueid";
	import Autocomplete from "@trevoreyre/autocomplete-vue";
	
	var XLSX = require("xlsx");
	var clone = require("clone");

	import Vue from 'vue';
    import $ from "jquery";
    import * as json2csv from "json2csv";

	import store from "../store";
	import images from "./images";
	import videos from "./videos";
	import categories from "./categories";
	import ace_editor from "./ace_editor.vue";
	import viewFile from "./viewFileSimplify.vue";

	export default {
		name: "edit_tabulator",
		components: {
			ace_editor,
			autocomplete: Autocomplete,
			images,
			videos,
			categories,
			viewFile
		},
		data: function () {
			return {
				mode: "tabulator",

				currentPage: 1,
				pageSize: 8,
				currentLineIndex: 1,
				nb_items: 1,
				rules: null,

				integration: { updateStrategy: "REPLACE" },

				tabulator_data: [],
				tabulator_options: {
					columns: [],
				},
				pagination: 10,
				name_column: "",
				line: {},
				input_menu: "",
				id: uniqueId(""),

				column_import_opt: [],
				option_delete: false,
				selected: "active",

				data_search: "",
				index: "id",

				paginationSize: 10,

				initialColumns: [],
				name_columns: [],
				columns_hide: [],
				columns_obj: {},
				columnFilters: [],
				filterColumns: false,

				wasRedrawn: false,
				idx_images: 0,
				idx_videos: 0,

				edit_text: "",
				edit_cell: null,

				prev_page: null,
				is_prev_page: false,
				page: 0,

				elems: {},
				objs_update: [],

				view_file: false,
				change_to_apply: {},

				new_line: {},

				hidden_columns: {}
			};
		},
		computed: {
			paginatedData() {
				const start = (this.currentPage - 1) * this.pageSize;
				const end = start + this.pageSize;
				return this.tabulator_data.slice(start, end);
			},
		},
		props: {
			select_mode: {
				defaut: false
			},
			hidden: {
				default: false
			},
			extern_file: {
				default: true,
				type: Boolean,
			},
			selectable: {
				default: false,
				type: Boolean,
			},
			minimal: {
				default: false
			},
			editor: {
				default: true
			},
			download: {
				default: true
			},
			hide_less_column: {
				default: false
			},
			columns_type: {
				default: () => {}
			},
			black_white_lists_edit: {},
			categories: {
				default: () => null
			},
			row_updates: {
				default: () => true
			},
			_index: {
				default: "id"
			}
		},
		watch: {
			_index: {
				handler() {
					this.tabulator_options.index = this._index;
					this.index = this._index;
				}
			},
			tabulator_data: {
				deep: true,
				handler() {
					//console.log(this.get_data())

                    // TODO penser à redraw ici lorsque les colonnes changent ?

					if (this.tabulator_data.length > 10)
						this.tabulator_options.pagination = "local";
					else this.tabulator_options.pagination = false;
					var self = this;
					this.$nextTick(() => {
						var data = self.get_data();
						self.$emit("data_length", data.length);
						self.$emit("update", self.id, data);
					});
				},
			},
			paginationSize(newVal, oldVal) {
				this.tabulator_options.paginationSize = newVal;
			},
		},
		methods: {
			hide_modal()
			{
				this.edit_cell.setValue(this.edit_text);
			},
			new_column(columns, column)
			{
				//console.log(this.columns_type)
				var self = this;
				if (column == "type_action")
					columns.unshift({
						title: column,
						field: column,
						editor: this.editor ? "textarea" : false,
						headerContextMenu: this.headerMenu,
					});
				else if (this.columns_type && this.columns_type[column] && this.columns_type[column].type == "image")
				{
					this.tabulator_options.layout = "fitData"
					var field = column;
					var width = 250;
					if (this.columns_type[column].params && this.columns_type[column].params.width)
						width = this.columns_type[column].params.width;
					columns.push({
						width: width,
						title: column,
						field: column,
						editor: false,
						tooltip: false,
						formatter:function(cell, formatterParams, onRendered){
							var id = uniqueId();
							onRendered(function(){
								document.getElementById("btn" + id).click();
							});
							return "<div style='height:30px; font-size:0px' id='id" + id + "'><button id='btn" + id + "' onclick=\"var event = new CustomEvent('message" + self.id + "', {detail: {id: '" + id + "', index: " + cell.getRow().getPosition() + ", type: 'image', edit: " + ( (self.columns_type[column] && self.columns_type[column].edit) ? 'true' : 'false' ) + ", black_white_lists_edit: " + ( (self.columns_type[column] && self.columns_type[column].hasOwnProperty("black_white_lists_edit") ? (self.columns_type[column].black_white_lists_edit ? 'true' : 'false') : "null" ) + ", black_white_lists: " + ( (self.columns_type[column] && self.columns_type[column].black_white_lists) ? 'true' : 'false' )) + ", name: '" + field.replace(/'/, "\'") + "'}}); window.dispatchEvent(event);\">" + cell.getValue() + "</button></div>";
						},
						headerContextMenu: this.headerMenu,
					});
					this.columns_obj[field] = columns.length - 1;
				}
				else if (this.columns_type && this.columns_type[column] && this.columns_type[column].type == "video")
				{
					this.tabulator_options.layout = "fitData"
					var field = column;
					var width = 250;
					if (this.columns_type[column].params && this.columns_type[column].params.width)
						width = this.columns_type[column].params.width;
					columns.push({
						width: width,
						title: column,
						field: column,
						editor: false,
						tooltip: false,
						formatter:function(cell, formatterParams, onRendered){
							var id = uniqueId();
							onRendered(function(){
								document.getElementById("btn" + id).click();
							});
							return "<div style='height:30px; font-size:0px' id='id" + id + "'><button id='btn" + id + "' onclick=\"var event = new CustomEvent('message" + self.id + "', {detail: {id: '" + id + "', index: " + cell.getRow().getPosition() + ", type: 'video', edit: " + ( (self.columns_type[column] && self.columns_type[column].edit) ? 'true' : 'false' ) + ", black_white_lists_edit: " + ( (self.columns_type[column] && self.columns_type[column].hasOwnProperty("black_white_lists_edit") ? (self.columns_type[column].black_white_lists_edit ? 'true' : 'false') : "null" ) + ", black_white_lists: " + ( (self.columns_type[column] && self.columns_type[column].black_white_lists) ? 'true' : 'false' )) + ", name: '" + field.replace(/'/, "\'") + "'}}); window.dispatchEvent(event);\">" + cell.getValue() + "</button></div>";
						},
						headerContextMenu: this.headerMenu,
					});
					this.columns_obj[field] = columns.length - 1;
				}
				else if (this.columns_type && this.columns_type[column] && this.columns_type[column].type == "category")
				{
					this.tabulator_options.layout = "fitData"
					var field = column;
					columns.push({
						width: this.columns_type[column].params.width || 250,
						title: column,
						field: column,
						editor: false,
						tooltip: false,
						formatter:function(cell, formatterParams, onRendered){
							var id = uniqueId();
							onRendered(function(){
								document.getElementById("btn" + id).click();
							});
							return "<div style='height:50px; font-size:0px' id='id" + id + "'><button id='btn" + id + "' onclick=\"var event = new CustomEvent('message" + self.id + "', {detail: {id: '" + id + "', index: " + cell.getRow().getPosition() + ", type: 'category', edit: " + ( (self.columns_type[column] && self.columns_type[column].edit) ? 'true' : 'false' ) + ", black_white_lists: " + ( (self.columns_type[column] && self.columns_type[column].black_white_lists) ? 'true' : 'false' ) + ", name: '" + field.replace(/'/, "\'") + "'}}); window.dispatchEvent(event);\">" + cell.getValue() + "</button></div>";
						},
						headerContextMenu: this.headerMenu,
					});
					this.columns_obj[field] = columns.length - 1;
				}
				else if (this.columns_type && this.columns_type[column] && this.columns_type[column].type == "file")
				{
					this.tabulator_options.layout = "fitData"
					var field = column;
					columns.push({
						width: this.columns_type[column].params.width || 250,
						title: column,
						field: column,
						editor: false,
						tooltip: false,
						cellClick: function (e, cell) {
							console.log("cellClick viewfile")

							self.view_file = cell.getValue();

							self.$bvModal.show("et-"+self.id);

						},
						headerContextMenu: this.headerMenu,
					});
					this.columns_obj[field] = columns.length - 1;
				}
				else if (this.columns_type && this.columns_type[column])
				{
					var new_column = {
						title: column,
						field: column,
						editor: this.editor ? "textarea" : false,
						headerContextMenu: this.headerMenu,
					};

					if (this.columns_type[column] && this.columns_type[column].params)
					{
						if (this.columns_type[column].params.hasOwnProperty("formatter"))
							new_column.formatter = this.columns_type[column].params.formatter;
						if (this.columns_type[column].params.hasOwnProperty("editor"))
							new_column.editor = this.columns_type[column].params.editor;
						if (this.columns_type[column].params.hasOwnProperty("editorParams"))
							new_column.editorParams = this.columns_type[column].params.editorParams;
						if (this.columns_type[column].params.width)
							new_column.width = this.columns_type[column].params.width;
					}

					columns.push(new_column);
				}
				else
					columns.push({
						//maxInitialWidth: 250,
						width: 250,
						title: column,
						field: column,
						editor: this.editor ? "textarea" : false,
						headerContextMenu: this.headerMenu,
					});

				return columns;
			},
			hide_column(column)
			{
				var tabulator_column = this.$refs.tabulator.getInstance().getColumn(column);

				if (!this.hidden_columns[column])
				{
					tabulator_column.hide();
					this.$set(this.hidden_columns, column, true);
				}
				else
				{
					tabulator_column.show();
					this.$delete(this.hidden_columns, column);
				}
			},
			hide_column_items()
			{
				var columns = this.$refs.tabulator.getInstance().getColumns();

				for (let column of columns) {
					var nb = 0;

					for (var i = 0; i < this.tabulator_data.length; i++)
					{
						if (this.tabulator_data[i][column.getField()])
							nb++;
						if (nb > this.nb_items)
							break;
					}

					if (nb < this.nb_items)
					{
						column.hide();
						this.$set(this.hidden_columns, column.getDefinition().title, true);
					}
					/*else
					{
						column.show();
						if (this.hidden_columns[column.getDefinition().title])
							this.$delete(this.hidden_columns, column.getDefinition().title);
					}*/
				}
			},
			hide_all()
			{
				var columns = this.$refs.tabulator.getInstance().getColumns();

				for (let column of columns) {
					column.hide();
					this.$set(this.hidden_columns, column.getDefinition().title, true);
				}
			},
			show_all()
			{
				var columns = this.$refs.tabulator.getInstance().getColumns();

				for (let column of columns) {
					column.show();
					if (this.hidden_columns[column.getDefinition().title])
						this.$delete(this.hidden_columns, column.getDefinition().title);
				}
			},
			applyColumnFilters() {
				var columns = this.$refs.tabulator.getInstance().getColumns();

				for (let column of columns) {
					let title = column.getDefinition().title;

					if (this.columnFilters.length === 0) {
						column.show();
					} else {
						for (let i = 0; i < this.columnFilters.length; i++) {
							let colFilter = this.columnFilters[i];

							if (
								title
									.toLowerCase()
									.indexOf(colFilter.toLowerCase()) > -1
							) {
								column.show();
								break;
							} else {
								column.hide();
							}
						}
					}
				}
			},
			removeColumnFilter(i) {
				this.columnFilters.splice(i, 1);
				this.applyColumnFilters();
			},
			addColumnFilter(val) {
				if (val === undefined || this.columnFilters.includes(val))
					return;
				this.columnFilters.push(val);

				this.$refs.columnFilter.value = "";
				this.applyColumnFilters();
			},
			searchCol(input) {
				if (input.length < 1) {
					// this.tabulator_options.columns = this.initialColumns;
					return [];
				}

				let filteredCols = this.initialColumns.filter((col) => {
					return (
						col.title.toLowerCase().indexOf(input.toLowerCase()) >
						-1
					);
				});

				// if (filteredCols.length == 0) {
				//     this.tabulator_options.columns = this.initialColumns;
				// } else {
				//     this.tabulator_options.columns = filteredCols;
				// }

				filteredCols = filteredCols.map((col) => {
					return col.title;
				});

				return filteredCols;
			},
			applyPagination: function () {
				this.tabulator_options.paginationSize = this.pagination;
			},
			headerMenu: function () {
				var menu = [];
				var self = this;
				var columns = this.$refs.tabulator.getInstance().getColumns();

				for (let column of columns) {
					//create checkbox element using font awesome icons
					let icon = document.createElement("i");
					icon.classList.add("fas");
					icon.classList.add(
						column.isVisible() ? "fa-check-square" : "fa-square"
					);

					//build label
					let label = document.createElement("span");
					let title = document.createElement("span");

					title.textContent = " " + column.getDefinition().title;

					label.appendChild(icon);
					label.appendChild(title);

					//create menu item
					menu.push({
						label: label,
						action: function (e) {
							//prevent menu closing
							e.stopPropagation();

							//toggle current column visibility
							column.toggle();

							//change menu item icon
							if (column.isVisible()) {
								icon.classList.remove("fa-square");
								icon.classList.add("fa-check-square");
							} else {
								icon.classList.remove("fa-check-square");
								icon.classList.add("fa-square");
							}
						},
					});
				}

				menu = [
					{
						label: function (component) {
							//component - column/cell/row component that triggered the menu

							return (
								"<input onChange='setInputMenu_edit" +
								self.id +
								"(this.value)' onClick='event.stopPropagation();'></input> Changer les valeurs de la colonne"
							);
						},
						action: function (e, column) {
							var table = self.$refs.tabulator.getInstance();
							var name = column.getDefinition().field;

							var rows = [];
							if (self.selected == "active")
								rows = self.$refs.tabulator
									.getInstance()
									.getRows();
							else
								rows = self.$refs.tabulator
									.getInstance()
									.getSelectedRows();
							for (var i = 0; i < rows.length; i++) {
								var data = {};
								data[name] = self.input_menu;
								rows[i].update(data);
							}
						},
					}]

				if (this.row_updates)
				{
					menu.push({
						label: function (component) {
							//component - column/cell/row component that triggered the menu

							return (
								"<input onChange='setInputMenu_edit" +
								self.id +
								"(this.value)' onClick='event.stopPropagation();' value='" +
								component.getDefinition().title +
								"'></input> Changer nom"
							);
						},
						action: function (e, column) {
							var table = self.$refs.tabulator.getInstance();
							var name = column.getDefinition().field;
							column.updateDefinition({
								width: 250,
								field: self.input_menu,
								title: self.input_menu,
							});
							var columns = table.getColumnDefinitions();
							var new_columns = [];
							for (var i = 0; i < columns.length; i++) {
								if (columns[i].field != name)
									new_columns.push(columns[i]);
							}
							self.tabulator_options.columns = new_columns;
							self.initialColumns = new_columns;
							for (
								var i = 0;
								i < self.tabulator_data.length;
								i++
							) {
								self.tabulator_data[i][self.input_menu] =
									self.tabulator_data[i][name];
								self.$delete(self.tabulator_data[i], name);
							}
						},
					});

					menu.push(
					{
						label: "Supprimer colonne",
						action: function (e, column) {
							var name = column.getDefinition().field;
							column.delete();
							var table = self.$refs.tabulator.getInstance();
							var columns = table.getColumnDefinitions();
							var new_columns = [];
							for (var i = 0; i < columns.length; i++) {
								if (columns[i].field != name)
									new_columns.push(columns[i]);
							}
							self.tabulator_options.columns = new_columns;
							self.initialColumns = new_columns;
							//console.log(name)
							for (
								var i = 0;
								i < self.tabulator_data.length;
								i++
							) {
								self.$delete(self.tabulator_data[i], name);
							}
						},
					});
				}
				/*menu.push(
				{
					label: 'colonnes <i class="fas fa-chevron-right"></i>',
					menu: menu,
				});*/

				return menu;
			},
			save() {
				return this.tabulator_data;
			},
			load(data) {
				this.set_data(data);
			},
			redraw: function (validate) {
				if (this.tabulator_data.length > 0 && this.$refs.tabulator && validate) {
                    //console.log("Redrawing tabulator");
					this.$refs.tabulator.getInstance().redraw(true);
					this.wasRedrawn = true;
				}
			},
			get_id: function () {
				return this.id;
			},
			get_data: function (blob) {
				if (this.selected != "active")
					return this.$refs.tabulator.getInstance().getSelectedData();
				else {
					return this.$refs.tabulator.getInstance().getData("active");
				}
			},
			get_data_blob: async function () {
				var self = this;

				var data = this.get_data();

				data = json2csv.parse(data, {
					fields: Object.keys(data.length > 0 ? data[0] : []),
					fieldNames: Object.keys(data.length > 0 ? data[0] : []),
				});

				data = new Blob([data], {
					type: "text/plain",
				});

				return data;
			},
			get_data_files: async function (all_files = true) {
				var self = this;

				//console.log("get_data_files " + all_files)
				/*if (!all_files)
				{
					return [];
				}*/

				var data = await this.get_data_blob();

				return [
					new File([data], "data.csv", {
						type: "text/csv",
					}),
				];
			},
			set_index(index) {
				this.tabulator_options.index = index;
				this.index = index;
			},
			set_option_delete(option_delete) {
				this.option_delete = option_delete;
			},
			set_column_import_opt(column_import_opt) {
				this.column_import_opt = column_import_opt;
			},
			set_pagination: function (pagination = 10) {
				this.paginationSize = pagination;
				this.tabulator_options.pagination = pagination;
			},
			add_data: function(data)
			{
				this.tabulator_data = this.tabulator_data.concat(data);
			},
			eventListener: async function(event){
				var self = this;
				var id = event.detail.id;
				var column = event.detail.name;
				var edit = event.detail.edit;
				var index = event.detail.index;
				var text = document.getElementById("id" + id).textContent;

				if (event.detail.type == "image")
				{
					this.idx_images++;
					let imagesComp = Vue.extend(images)
					let image = new imagesComp({
						propsData: {
							source: text,
							column: column,
							index: index,
							black_white_lists: event.detail.black_white_lists || false,
							idx: this.idx_images,
							edit: edit,
							black_white_lists_edit: event.detail.black_white_lists_edit !== null ? event.detail.black_white_lists_edit : this.black_white_lists_edit
						}
					});
					image.$on('width', (width, column) => {
							var nb = self.columns_obj[column];
							if (width > self.tabulator_options.columns[nb].width)
								self.tabulator_options.columns[nb].width = width;
						});
					image.$on('update', (index, column, categories) => {
						this.$emit("update_cell", index, column, categories);
					});
					image.$mount('#id' + id);
				}
				else if (event.detail.type == "video")
				{
					this.idx_videos++;
					let videosComp = Vue.extend(videos)
					let video = new videosComp({
						propsData: {
							source: text,
							column: column,
							index: index,
							black_white_lists: event.detail.black_white_lists || false,
							idx: this.idx_videos,
							edit: edit,
							black_white_lists_edit: event.detail.black_white_lists_edit !== null ? event.detail.black_white_lists_edit : this.black_white_lists_edit
						}
					});
					video.$on('width', (width, column) => {
							var nb = self.columns_obj[column];
							if (width > self.tabulator_options.columns[nb].width)
								self.tabulator_options.columns[nb].width = width;
						});
					video.$on('update', (index, column, categories) => {
						this.$emit("update_cell", index, column, categories);
					});
					video.$mount('#id' + id);
				}
				else if (event.detail.type == "category")
				{
					let categoriesComp = Vue.extend(categories)
					let category = new categoriesComp({
						propsData: {
							source: text,
							column: column,
							index: index,
							categories: this.categories,
							edit: edit,
							idx: this.idx_images,
						}
					});
					category.$on('update', (index, column, categories) => {
						this.$emit("update_cell", index, column, categories);
					});
					category.$mount('#id' + id);
					this.elems[index + " " + column] = category;
				}
			},
			set_data: function (data, name_columns = null, type) {
				var self = this;

				this.idx_images = 0;

				if (!Array.isArray(data))
					data = [];

				var fields = Object.keys(data.length > 0 ? data[0] : []);
				var columns = [];
				if (this.name_columns)
					this.name_columns = name_columns;
				for (var i = 0; i < fields.length; i++) {
					if (!name_columns || (name_columns && name_columns.includes(fields[i])))
					{
						columns = this.new_column(columns, fields[i]);
					}
				}
				if (this.option_delete) {
					columns.push({
						formatter: "buttonCross",
						width: 40,
						align: "center",
						cellClick: function (e, cell) {
							cell.getRow().delete();
						},
					});
				}
				this.tabulator_data = clone(data);

				//console.log(type)
				//console.log(clone(this.tabulator_data))

				this.tabulator_options.columns = columns;
				this.initialColumns = columns;
			},
			set_data_cell(index, column, data, apply)
			{
				var self = this;

				if (apply)
				{
					var obj = {};
					obj[column] = data;
					obj[this._index] = index;
					
					this.objs_update.push(obj)
					//console.log("set_data_cell");
					this.$refs.tabulator.getInstance().updateData(this.objs_update);
					//console.log("set_data_cell - end ");
					this.objs_update = [];
				}
				else
				{
					if(!this.change_to_apply[index])
						this.change_to_apply[index] = {};
					this.change_to_apply[index][column] = data;
				}
			},
			set_data_cell_apply(columns)
			{
				//console.log('tabulator set_data_cell_apply')
				for (var i = 0; i < this.tabulator_data.length; i++)
                {
                    if (this.change_to_apply[this.tabulator_data[i][this.index]])
                    {
                        var keys = Object.keys(this.change_to_apply[this.tabulator_data[i][this.index]]);
                        for (var j = 0; j < keys.length; j++)
                        {
                            this.tabulator_data[i][keys[j]] = this.change_to_apply[this.tabulator_data[i][this.index]][keys[j]];
                        }
                    }
                }
				this.change_to_apply = {};
				if (this.tabulator_data.length > 0 && columns)
					this.set_columns(Object.keys(this.tabulator_data[0]));
				//console.log('tabulator set_data_cell_apply end')
			},
			set_columns: function (columns) {
				//console.log("set columns")

				var _columns = [];
				for (var i = 0; i < columns.length; i++) {
					_columns = this.new_column(_columns, columns[i]);
				}
				if (this.option_delete) {
					_columns.push({
						formatter: "buttonCross",
						width: 40,
						align: "center",
						cellClick: function (e, cell) {
							cell.getRow().delete();
						},
					});
				}
				this.tabulator_options.columns = _columns;
				this.initialColumns = _columns;
			},
			dowloadCSV: function (dowload = true) {
				const tabulatorInstance = this.$refs.tabulator.getInstance();
				this.dowload = true;
				tabulatorInstance.download(
					"csv",
					"data.csv",
					{},
					this.selected
				);
			},
			dowloadExcel: function (dowload = true) {
				const tabulatorInstance = this.$refs.tabulator.getInstance();
				this.dowload = true;
				tabulatorInstance.download(
					"xlsx",
					"data.xlsx",
					{},
					this.selected
				);
			},
			search: async function () {
				function matchAny(data, filterParams) {
					//data - the data for the row being filtered
					//filterParams - params object passed to the filter

					var match = false;

					for (var key in data) {
						if (
							typeof data[key] == "string" &&
							data[key].toLowerCase().includes(filterParams.value.toLowerCase())
						) {
							match = true;
						}
					}

					return match;
				}

				//set filter to custom function
				this.$refs.tabulator
					.getInstance()
					.setFilter(matchAny, { value: this.data_search });
			},
			addTabulator: async function (event = null) {
				//console.log("add Tabulator")
				var self = this;

				var file = null;
				if (event.dataTransfer)
					file = event.dataTransfer.files[0];
				else
					file = event.target.files[0];
				if (file)
					this.name_file_tabulator = file.name;
				var str = await file.arrayBuffer();
				if (this.name_file_tabulator && (this.name_file_tabulator.endsWith(".xlsx") || this.name_file_tabulator.endsWith(".xls")))
				{
					var workbook = XLSX.read(str, { bookType: "csv", dateNF:'yyyy-mm-dd'});
					self.tabulator_data = XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]], {raw:false, defval: ""});
					//console.log(workbook)
					//console.log(self.tabulator_data)
					var columns_keys = Object.keys(self.tabulator_data[0]);
					var columns = []
					for (var i = 0; i < columns_keys.length; i++)
					{
						columns = this.new_column(columns, columns_keys[i])
					}
					self.tabulator_options.columns = columns;
					self.initialColumns = columns;
					self.$refs["edit_file_" + self.id].reset();
				}
				else
				{
					var encoding = chardet.detect(Buffer.from(str));
					var str = new TextDecoder().decode(str);
					var separator = CSV.detect(str);
					if (separator != "," && separator != ";" && separator != "\t")
						separator = ",";
					this.$papa.parse(file, {
						encoding: encoding,
						delimiter: separator,
						header: true,
						skipEmptyLines: true,
						complete: function (results) {
							self.tabulator_data = results.data;
							var fields = results.meta.fields;
							var columns = [];
							for (var i = 0; i < fields.length; i++) {
								columns = self.new_column(columns, fields[i]);
							}
							if (self.option_delete) {
								columns.push({
									formatter: "buttonCross",
									width: 40,
									align: "center",
									cellClick: function (e, cell) {
										cell.getRow().delete();
									},
								});
							}
							self.tabulator_options.columns = columns;
							self.initialColumns = columns;
							self.$refs["edit_file_" + self.id].reset();
						},
					});
				}
			},
			addLine: function (first = false) {
				var data = {};
				for (
					var i = 0;
					i < this.tabulator_options.columns.length;
					i++
				) {
					if (this.new_line[this.tabulator_options.columns[i].title])
						data[this.tabulator_options.columns[i].title] = this.new_line[this.tabulator_options.columns[i].title];
					//else if (this.tabulator_options.columns[i].title == this.index)
					//	data[this.tabulator_options.columns[i].title] = this.tabulator_data.length * -1;
					else 
						data[this.tabulator_options.columns[i].title] = "";
				}
				this.new_line = {};

				if (first)
					this.tabulator_data.push(data);
				else
					this.tabulator_data.unshift(data);
			},
			addColumn: function () {
				if (this.name_column.trim()) {
					this.tabulator_options.columns.push({
						title: this.name_column.trim(),
						field: this.name_column.trim(),
						editor: this.editor ? "textarea" : false,
						width: 200,
						headerContextMenu: this.headerMenu,
					});
					for (var i = 0; i < this.tabulator_data.length; i++) {
						this.tabulator_data[i][this.name_column.trim()] = "";
					}
					if (this.column_import_opt[this.name_column.trim()]) {
						for (var i = 0; i < this.tabulator_data.length; i++) {
							if (
								!this.tabulator_data[i][this.name_column.trim()]
							)
								this.tabulator_data[i][
									this.name_column.trim()
								] =
									this.column_import_opt[
										this.name_column.trim()
									];
						}
					}
				}

				var self = this;
				this.$nextTick(() => {
					self.$emit("update", self.id, self.get_data());
				});
			},
			setInputMenu(input_menu) {
				this.input_menu = input_menu;
			},
		},
		destroyed() {
			this.$el.removeEventListener('message' + this.id, this.eventListener);
		},
		mounted: async function () {
			//console.log("edit_tabulator")

			window.addEventListener('message' + this.id, this.eventListener);

			this.$loadScript(
				"https://oss.sheetjs.com/sheetjs/xlsx.full.min.js"
			);

			if (store.state.user.rules && store.state.user.rules.tabulator_button)
				this.rules = store.state.user.rules.tabulator_button;

			var self = this;
			this.resolve = null;

			window["setInputMenu_edit" + this.id] = this.setInputMenu;

			this.tabulator_options = {
				layout: "fitDataTable",
				columns: [],
				//columnMaxWidth: 1000,
				tooltips: true, //show tool tips on cells
				addRowPos: "top", //when adding a new row, add it to the top of the table
				history: true, //allow undo and redo actions on the table
				movableColumns: true, //allow column order to be changed
				resizableRows: true, //allow row order to be changed
				data: this.tabulator_data,
				pagination: false,
				paginationSize: 10,
				selectable: false,
				downloadRowRange: this.selected,
				nestedFieldSeparator: false,
				index: this._index || "id",
				dataChanged: function (data) {
					//console.log("dataChanged")
					self.tabulator_data = data;
				},
				downloadReady: function (fileContents, blob) {
					self.tabulator_data_csv = blob;
					if (self.dowload == false) {
						self.resolve();
						return false;
					} else {
						self.dowload = false;
						return blob;
					}
				},
				rowUpdated: function (row) {
					self.$emit("update_row", self.id, row);
				},
				rowDeleted: function (row) {
					self.$emit("delete_row", self.id, row);
				},
				rowAdded: function (row) {
					self.$emit("add_row", self.id, row);
				},
				cellClick: function (e, cell)
				{
					var column = cell.getColumn().getField();
					if (!(self.columns_type && self.columns_type[column] && 
						(
							self.columns_type[column].type == "image" || 
							self.columns_type[column].type == "video" || 
							self.columns_type[column].type == "file")) 
						&& cell.getValue().length > 100)
					{
						console.log("cellClick")
						self.edit_text = cell.getValue();
						self.edit_cell = cell;
						this.view_file = false;
						self.$bvModal.show("et-"+self.id);
					}
				},
				cellEdited: function (cell) {
					//console.log("update_cell")
					self.$emit(
						"update_row",
						self.id,
						cell.getRow(),
						cell.getField()
					);
					self.$emit(
						"update_cell",
						cell.getRow().getIndex(),
						cell.getColumn().getField(),
						cell.getValue()
					);
				},
				columnVisibilityChanged: function (column, visible) {
					//column - column component
					//visible - is column visible (true = visible, false = hidden)
					//("columnVisibilityChanged")
					var self = this;
					self.$nextTick(() => {
						self.$emit("update", self.id, self.get_data());
					});
				},
				rowSelectionChanged: function (data, rows) {
					if (data.length == 0)
						self.selected = "active";
					else
						self.selected = "selected";
					if (self.selected == "active")
					{
						self.$emit("data", self.tabulator_data);
						self.$emit("data_length", self.tabulator_data.length);
					}
					else
					{
						var data = self.$refs.tabulator.getInstance().getSelectedData();
						self.$emit("data", data);
						self.$emit("data_length", data.length);
					}
				},
				pageLoaded: function(pageno)
				{
					if (!self.prev_page)
						self.prev_page = pageno;
					else if (pageno == 1)
						self.is_prev_page = true;
					//console.log("page change : " + pageno)
					//console.log(self.page)
					if (pageno > 1 || (self.page > 1 && pageno == 1))
						document.getElementById(self.id).scrollIntoView();
					self.page = pageno;
					setTimeout(() => {
						//console.log(self.prev_page + " " + self.is_prev_page)
						if (self.prev_page && self.is_prev_page)
						{
							self.$refs.tabulator.getInstance().setPage(self.prev_page);
							//console.log("return to page " + self.prev_page)
						}
						self.prev_page = null;
						self.is_prev_page = false;
					}, "200");
				},
				rowContextMenu: [
					{
						label: "Sélectionner la ligne",
						action: function (e, row) {
							row.select();
							self.$emit("update", self.id, self.get_data());
						},
					},
					{
						label: "Sélectionner multiples lignes",
						action: function (e, row) {
							var rows = self.$refs.tabulator
								.getInstance()
								.getSelectedRows();
							if (rows.length > 0) {
								var pos_first =
									rows[rows.length - 1].getPosition(true);
								var pos_last = row.getPosition(true);

								if (pos_first > pos_last) {
									var _pos = pos_first;
									pos_first = pos_last;
									pos_last = _pos;
								}

								var rows = self.$refs.tabulator
									.getInstance()
									.getRows();

								for (var i = pos_first; i <= pos_last; i++) {
									rows[i].select();
								}
							} else row.select();

							self.$emit("update", self.id, self.get_data());
						},
					},
					{
						label: "Ne plus sélectionner la ligne",
						action: function (e, row) {
							row.deselect();

							self.$emit("update", self.id, self.get_data());

						},
					},
					{
						label: "Déselectionner toutes les lignes",
						action: function (e, row) {
							var rows = self.$refs.tabulator
								.getInstance()
								.getSelectedRows();
							for (var i = 0; i < rows.length; i++) {
								rows[i].deselect();
							}

							self.$emit("update", self.id, self.get_data());
						},
					}
				],
			};

			if (this.row_updates)
			{
				this.tabulator_options.rowContextMenu.push(
				{
					label: "Supprimer ligne",
					action: function (e, row) {
						row.delete();
						self.tabulator_data = self.$refs.tabulator
							.getInstance()
							.getData();
					}
				});
				this.tabulator_options.rowContextMenu.push(
				{
					label: "Duppliquer ligne",
					action: function (e, row) {
						self.tabulator_data.push(
							Object.assign({}, row.getData())
						);
					}
				});
			}

			if (this.select_mode)
			{
				this.tabulator_options.rowContextMenu.push(
				{
					label: "Voir ligne",
					action: function (e, row) {
						console.log(row)
						self.currentLineIndex = row.getPosition() + 1;
						console.log(self.currentLineIndex)
						self.mode = "individual"
					}
				});
			}
		},
	};
</script>

<style>
	.search-col .autocomplete-input {
		height: 2rem !important;
	}
</style>

<style>
	.center_spinner {
		width: 0%;
		margin: 0 auto;
		margin-top: 30px;
	}

	.tabulator-menu {
		position: absolute;
		background-color: white;
		border: 1px solid;
		cursor: pointer;
		padding: 5px;
	}

	.tabulator-menu div:hover {
		background-color: rgb(165, 241, 255);
	}
	.collapse
	{
		visibility: visible !important
	}
	.card-grid {
		display: grid;
		grid-template-columns: repeat(4, 1fr);
		gap: 1rem;
		margin-bottom: 2rem;
	}

	.card {
		border: 1px solid #ddd;
		border-radius: 8px;
		padding: 1rem;
		background-color: white;
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
	}

	.card-content {
		display: flex;
		flex-direction: column;
	}
</style>
